import { useState } from "react";
import "./SoloSlide.scss";
import { baseUrl } from "../../utils/apiData";

const SoloSlide = ({ data, classList }) => {
  const [slide, setSlide] = useState(0);

  const prevHandler = () => {
    setSlide((prev) => {
      return prev === 0 ? data?.images?.length - 1 : prev - 1;
    });
  };

  const nextHandler = () => {
    setSlide((prev) => prev + 1);
  };

  return (
    <div className={`slid_box_wrap ${classList}`}>
      <div className="img_box_wrap">
        {data?.images?.map((item, k) => {
          return (
            <img
              src={`${baseUrl}/${item}`}
              alt="Slide"
              style={{
                opacity: `${slide % data?.images?.length === k ? 1 : 0}`,
              }}
              key={k}
            />
          );
        })}
      </div>
      <div className="main_content">
        <div className="dot_wrap">
          {data?.images?.map((item, j) => {
            return (
              <span
                className={slide % data?.images?.length === j ? "active" : ""}
                key={j}
              ></span>
            );
          })}
        </div>
        <h4 className="gold">{data?.title}</h4>
        <p className="gold">{data?.description}</p>
      </div>
      <div id="leftLayer" onClick={prevHandler}></div>
      <div id="rightLayer" onClick={nextHandler}></div>
    </div>
  );
};
export default SoloSlide;
